export default "__VITE_ASSET__64ee7875__"